module.exports = __webpack_public_path__ + "node_modules/icheck/skins/square/orange@2x.png?b9b55a91";